import { Component, OnInit, Inject, OnDestroy } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'transactions-dialog',
  templateUrl: '../sharedTemplates/transactions.dialog.html',
})
export class TransactionsDialog {
  bookingsList = [];

  Balance;
  Bonus;
  Deposit;
  LostAmount;
  OpenCount;
  TotalBet;
  WinAmount;
  Withdraw;

  selectedMonth;
  selectedYear;
  selectedTransType = 100; // 29-04-2022 tarihinde değişti . Eski yapıda 0 gönderiliyordu

  constructor(
    public dialogRef: MatDialogRef<TransactionsDialog>,
    private _ApiService: ApiService,
    public _LocalizationService: LocalizationService,
    public _UserHelper: UserHelper,
    private _router: Router,
    public _DataHelper: DataHelper,
    public _UiHelper: UiHelper
  ) {
    this.getBookings();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getBookings() {
    const today = new Date();
    const defaultMonth = today.getMonth();
    const defaultYear = today.getFullYear();

    this._ApiService.getBookings(defaultMonth, defaultYear, this.selectedTransType).then(x => {
      this.bookingsList = x;
      this.bookingLoginResult();
    });
  }

  bookingLoginResult() {
    this._ApiService.bookingLoginResult().then((x: any) => {
      this.Balance = x[0].Balance;
      this.Bonus = x[0].Bonus;
      this.Deposit = x[0].Deposit;
      this.LostAmount = x[0].LostAmount;
      this.OpenCount = x[0].OpenCount;
      this.TotalBet = x[0].TotalBet;
      this.WinAmount = x[0].WinAmount;
      this.Withdraw = x[0].Withdraw;
    });
  }

  goToBookings() {
    this._router.navigate(['/bookings']).then(x => {
      this.dialogRef.close();
    });
  }

  goToSlips() {
    this._router.navigate(['/slips']).then(x => {
      this.dialogRef.close();
    });
  }

  goToSports() {
    this._router.navigate(['/sports']).then(x => {
      this.dialogRef.close();
    });
  }

  goToHome() {
    this._router.navigate(['/home']).then(x => {
      this.dialogRef.close();
    });
  }

  ngOnDestroy() {
    this.Balance = '';
    this.Bonus = '';
    this.Deposit = '';
    this.LostAmount = '';
    this.OpenCount = '';
    this.TotalBet = '';
    this.WinAmount = '';
    this.Withdraw = '';
    this.bookingsList = [];
  }
}
